import { createSelector } from 'reselect'
import { selectEventZIndex } from '../system'
import { NEWS_AUTO_OPEN_BLOCKED_PATHS } from './constants'

export const selectIsNewsAutoOpenAllowed = (pathname: string) =>
	createSelector(
		selectEventZIndex,
		(eventZIndex: number) => eventZIndex === 0 && !NEWS_AUTO_OPEN_BLOCKED_PATHS.includes(pathname?.replace(/\/+$/, ''))
	)
